<template>
  <div class="detail-wrapper" v-if="detailData" :style="`background: ${ toRgba(activityData.themeColor) }`">
    <div class="detail-main">
      <div class="swiper" v-if="imgs.length && !detailData.info.video">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img
              :src="
                detailData.info.image.indexOf('?') > -1
                  ? detailData.info.image + '&imageView2/2/w/640'
                  : detailData.info.image + '?imageView2/2/w/640'
              "
              alt=""
            />
          </div>
          <div class="swiper-slide" v-for="item in imgs" :key="item">
            <img :src="item" alt="" />
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
      <div class="detail-img" v-else>
        <img
          v-if="!detailData.info.video"
          :src="
            detailData.info.image.indexOf('?') > -1
              ? detailData.info.image + '&imageView2/2/w/640'
              : detailData.info.image + '?imageView2/2/w/640'
          "
          alt=""
        />
        <video
          v-else
          :src="detailData.info.video"
          controls
          :poster="activityData.videoUniPoster ? activityData.videoUniPoster : slimImageFilter(detailData.info.image, 750, 420)"
        ></video>
      </div>
      <div class="detail-title-wrap">
        <div class="detail-vote-wrap" :style="`background: ${ activityData.themeColor };`" v-if="!activityData.isHideVote">
          <div class="detail-vote-inner">
            <span class="vote-num">{{ detailData.votes }}</span>&nbsp;票
          </div>
        </div>
        <div class="detail-title">
          <div v-html="detailData.info.title"></div>
          <i v-if="detailData.info.subtitle">{{ detailData.info.subtitle }}</i>
        </div>
      </div>
    </div>
    <div class="detail-body">
      <div class="detail-triangle"><div :style="`border-top: 100vw solid ${ activityData.themeColor || '#1E3485' };`"></div></div>
      <div class="detail-footer">
        <div class="detail-desc" v-html="detailData.info.intro"></div>
        <div class="detail-btn">
          <div class="back-btn" @click="backPage"></div>
          <div class="btf-vote-btn" @click="handleVote(detailData.id)" v-if="!activityData.isHideVote"></div>
        </div>
      </div>
    </div>
    

    <dialog-component
      @loginEvent="getUserInfon"
      @wxauthorizeEvent="wxAuthorizeCallback"
      :baseData="baseData"
    ></dialog-component>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.css";
import COVER from "@/utils/COVER";
import DialogComponent from "@/components/Dialog";
import COVERAPP from "@/utils/COVERAPP";
import FILTER from "@/utils/filters";

import moment from "moment";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      vid: "",
      detailData: null,
      openid: "",
      imgs: [],
    };
  },
  props: ["activityData", "baseData"],
  computed: {
    ...mapState(["dialogData", "userInfo", "aid"]),
  },
  components: {
    DialogComponent,
  },
  created() {
    this.vid = this.$route.query.vid || "";
    const aid = this.$route.query.id || "";
    if (!this.aid) this.setAid(aid);
    this.getDetail();
  },
  mounted() {
    if (COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
      this.getUserInfon();
    }
    setTimeout(() => {
      this.setPageLoadingAsync(false);
    }, 500);
  },
  methods: {
    ...mapMutations(["setUserInfo", "setOpenDownLoadFlag", "setAid"]),
    ...mapActions([
      "setPageLoadingAsync",
      "setDialogDataAsync",
      "setUserInfoAsync",
    ]),
    getUserInfon() {
      this.setUserInfoAsync();
    },
    slimImageFilter(img, imgW, imgH) {
      return FILTER.slimImageFilter(img, imgW, imgH);
    },
    //分享
    share() {
      let data = this.baseData.share;
      let shareData = {
        title: data.title,
        desc: data.desc,
        imgUrl: data.imgUrl,
        link: data.link || window.location.href,
      };
      COVER.share(shareData);
    },
    getShareData() {
      const _this = this;
      let shareData = this.baseData.share;
      return {
        title: "快来为TA打call，就差你了", // 分享标题
        desc: _this.detailData.info.title, // 分享描述
        link: window.location.href,
        imgUrl: shareData.imgUrl,
        type: "link",
        origin: "None",
        callback: function (res) {
          // 分享成功
          COVER.$post("/vote/share", {
            aid: _this.aid,
            uid: _this.userInfo.token,
            userinfo: _this.userInfo,
          }).then((ret) => {
            if (ret.errno == 0) {
              _this.setDialogDataAsync({
                message: "分享成功!",
                btns: [
                  {
                    text: "确认",
                  },
                ],
              });
              return;
            }
          });
        },
      };
    },
    // APP分享
    coverShare() {
      const _this = this;
      COVER.share(_this.getShareData());
    },
    // APP主动调起分享
    doShare() {
      const _this = this;
      COVERAPP.Method.Share(_this.getShareData());
    },
    getDetail() {
      const _this = this;
      COVER.$get(`/vote/${this.vid}`, {}).then((res) => {
        const info = res.data.info || {};
        let imgs = [];
        for (let x in info) {
          for (let i = 0; i < 10; i++) {
            if (x.indexOf("image" + i) > -1 && info[x]) {
              imgs.push(info[x]);
            }
          }
        }

        _this.detailData = res.data;
        _this.imgs = imgs;
        if (_this.activityData.external) {
          _this.coverShare();
        } else {
          _this.share();
        }
        this.$nextTick(() => {
          this.slide();
        });
      });
    },
    handleVote(id) {
      if (this.activityData.isAppHandle && !COVERAPP.Attribute.isApp()) {
        this.setOpenDownLoadFlag(true);
        return;
      }
      this.voteOptions = {
        aid: this.aid,
        uid: this.userInfo.token,
        vid: this.vid,
        userinfo: this.userInfo,
        openid: this.openid,
      };
      this.$nextTick(() => {
        this.vote(id);
      });
    },
    vote(id) {
      const _this = this;
      if (!COVERAPP.Attribute.isApp() && this.activityData.external) {
        if (
          localStorage.getItem(
            this.aid + "_skip_app_" + moment().format("YYYYMMDD")
          )
        ) {
          this.setDialogDataAsync({
            message:
              "投票次数已用完！到APP内投票，还可以额外获得每天50次的机会，赶紧使用吧！",
            btns: [
              {
                text: "确认",
                className: "downLoad-app",
              },
            ],
          });
          return;
        }
        this.setDialogDataAsync({
          message:
            "恭喜你，投票成功！到APP内投票，还可以额外获得每天50次的机会，赶紧使用吧！",
          btns: [
            {
              text: "确认",
              className: "downLoad-app",
            },
          ],
        });
        this.detailData.votes++;
        localStorage.setItem(
          this.aid + "_skip_app_" + moment().format("YYYYMMDD"),
          true
        );
        return;
      }
      if (!this.userInfo.token) {
        this.setDialogDataAsync({
          message: "参与活动，需登录!",
          btns: [
            {
              text: "去登录",
              className: "login-btn",
            },
            {
              text: "取消",
              className: "close-btn",
            },
          ],
        });
        return;
      }
      this.setDialogDataAsync({
        message: "投票中，请稍候...",
      });
      COVER.$post("/vote", this.voteOptions)
        .then((res) => {
          if (res.errno == 0) {
            const shareNoticeKey =
              this.voteOptions.aid +
              "_share_notice_" +
              moment().format("YYYYMMDD");
            if (
              this.activityData.shareCount &&
              !localStorage.getItem(shareNoticeKey)
            ) {
              // 今天第一次投票
              this.setDialogDataAsync({
                message:
                  "感谢你为我投票！分享后还能额外获得" +
                  this.activityData.shareCount +
                  "次投票机会，记得分享哦！",
                btns: [
                  {
                    text: "确认",
                    className: "share-btn",
                    callback: _this.doShare,
                  },
                ],
              });
              // 记录今天已投票
              localStorage.setItem(shareNoticeKey, true);
            } else {
              // 今天不是第一次投票
              this.setDialogDataAsync({
                message: "投票成功",
                btns: [
                  {
                    text: "确认",
                  },
                ],
              });
            }
            this.detailData.votes++;
          } else if (COVERAPP.Attribute.isApp() && res.errno == 1250) {
            this.setDialogDataAsync({
              message: "参与活动，需绑定微信!",
              btns: [
                {
                  text: "绑定微信",
                  className: "wxAuthorize-btn",
                },
                {
                  text: "取消",
                  className: "close-btn",
                },
              ],
            });
          } else if (res.errno == 2022) {
            this.setOpenDownLoadFlag(true);
          } else {
            this.setDialogDataAsync({
              message: res.errmsg || "投票失败，请重试",
              btns: [
                {
                  text: "确认",
                },
              ],
            });
          }
        })
        .catch(() => {
          this.setDialogDataAsync(null);
        });
    },
    wxAuthorizeCallback(openid) {
      let _this = this;
      let verifyOpenid = `${_this.userInfo.user_id.toString(
        36
      )}_${openid}_${(+moment().format("YYYYMMDD")).toString(36)}`;
      _this.userInfo.openid = openid;
      _this.openid = verifyOpenid;
      store.commit("setUserInfo", _this.userInfo);
    },
    backPage() {
      // this.$router.push(`/list?id=${this.aid}`);
      this.$router.push(`/?id=${this.aid}`);
    },
    slide() {
      new Swiper(".detail-wrapper .swiper", {
        loop: true,
        autoHeight: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
        },
      });
    },
    toRgba(c) {
      if (!c) {
        return;
      }
      return COVER.hexToRgba(c, 0.9);
    },
  },
};
</script>

<style lang="less">
.detail-wrapper {
  background: #2b4aa7;
  width: 100vw;
  min-height: 100vh;
  position: relative;
}
.detail-img {
  width: 100%;
  overflow: hidden;
  background-color: #eaeaea;
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #eaeaea;
  position: relative;
  border: 2px solid #000;
  border-bottom: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  video {
    width: 100%;
    background-color: #000;
    height: 5.6rem;
  }
}
.video-btn {
  width: 100%;
  height: 100%;
  background: url(https://yunyingcdn.thecover.cn/o_1c1uiks011tbds1u1djqbjj1vh6d.png)
    no-repeat center / 2rem auto;
  position: absolute;
  left: 0;
  top: 0;
}
.detail-title-wrap {
  background-color: #f4f3f9;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  min-height: 1.6rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border: 2px solid #000;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.detail-vote-wrap {
  width: 3.333333rem;
  background-color: #ff5847;
  font-size: 0.388889rem;
  color: #fff;
  margin: 0;
  /* text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%; */
  border-right: 2px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail-vote-inner {
  font-weight: 600;
  line-height: 1.3;
  position: relative;
}
.detail .vote-num {
  font-size: 0.555556rem;
}
.detail-title {
  font-size: 0.481481rem;
  color: #383838;
  font-weight: bold;
  padding: 0.4rem 0.53333rem;
  box-sizing: border-box;
  margin: 0;
  font-size: 0.4266666rem;
  color: #000;
  font-weight: 700;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  i {
    font-size: 0.3rem;
    color: #333;
    font-style: normal;
    font-weight: normal;
    display: block;
    margin-top: 0.1rem;
  }
}
.detail-title span {
  display: block;
  font-size: 0.3rem;
  padding-top: 0.1rem;
  line-height: 1.2;
  color: #666;
}
.detail-body {
  position: relative;
}
.detail-triangle {
  position: absolute;
  max-height: 100vw;
  width: 100%;
  overflow: hidden;
  z-index: -1;
  div {
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-left: 100vw solid transparent;
    border-bottom: 100vw solid transparent;
    border-top: 100vw solid transparent;
  }
}
.detail-footer {
  // background: url(../../../assets/images/btfvote/fill.png) no-repeat top;
  background-size: 100%;
  min-height: 10.0266666rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-bottom: 0.6rem;
  // position: absolute;
  z-index: 2;
}
.detail-desc {
  font-size: 0.4266666rem;
  color: #fff;
  padding: 0.601852rem 0.462963rem 0.8rem 0.555556rem;
  line-height: 0.8rem;
  word-break: break-all;
  box-sizing: border-box;
}
.detail-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  align-items: center;
  justify-content: space-around;
  padding: 0 0.5rem;
}
.back-btn {
  width: 3.52rem;
  height: 1.6rem;
  background: url(../../../assets/images/btfvote/detail2.png) no-repeat top;
  background-size: 100%;
}
.btf-vote-btn {
  width: 3.52rem;
  height: 1.6rem;
  background-size: 100%;
  background: url(data:image/png;base64,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)
    no-repeat top;
  background-size: 100%;
  box-sizing: border-box;
}
.btf-vote-btn.voted {
  color: #ff5847;
  border: 2px solid #ff5847;
  background: #fff;
}
</style>
